(function () {
  var revealEls = document.querySelectorAll('.tomica-home .reveal');
  if (!revealEls.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  revealEls.forEach(function (el) { observer.observe(el); });

  // Safety net: force everything visible after a short delay no matter
  // what, so nothing can stay permanently hidden.
  window.setTimeout(function () {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }, 2500);
})();